export const exception = {
    blacklistedRecruiter:
        'Die Kontaktaufnahme mit dem Talent ist aufgrund seiner Benutzereinstellungen derzeit nicht möglich.',
    unknown: 'Ein unbekannter Fehler ist aufgetreten.',
};
